import api from '../../utils/Api';

export const addNewMember = (data) => () => api.postAddNewMember(data);
